import { useTheme } from '../../context/ThemeContext.js';
import { Switch } from './Switch.js';

// 110 follow-up: sized to sit inside the switch's h-4 w-4 thumb, not the row.
const SunIcon = () => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="10"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41" />
  </svg>
);

const MoonIcon = () => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="10"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
  </svg>
);

export function ThemeToggle() {
  const { effectiveTheme, setTheme } = useTheme();
  const isDark = effectiveTheme === 'dark';

  return (
    <div className="flex items-center justify-between gap-3">
      <span className="text-sm text-ink">Dark mode</span>
      <Switch
        checked={isDark}
        onChange={() => setTheme(isDark ? 'light' : 'dark')}
        ariaLabel="Dark mode"
        icon={isDark ? <MoonIcon /> : <SunIcon />}
      />
    </div>
  );
}
